import { SET_CODE } from "../actions/action-types";
import { Reducer } from "redux";

const code: Reducer = (state = null, action) => {
  switch (action.type) {
    case SET_CODE:
      return action.code;
    default:
      return state;
  }
};

export default code;
